module.exports = __webpack_public_path__ + "img/dreamfill.a8555ebe.png";